<template>
  <div v-if="usps" class="hidden lg:block bg-[#262626] text-white">
    <div
      class="h-11 w-full flex items-center"
      v-bind="$attrs"
      :class="isCheckoutPage ? 'page-container--small' : 'page-container'">
      <Usps class="mr-4" color="transparent" />
      <div class="flex gap-4 ml-auto items-center">
        <CustomerSupportMenu />
        <LanguageMenuTopBar @click="close" />
        <!-- The checkout design leaves out the currency switch. -->
        <CurrencyMenu v-if="!isCheckoutPage" @click="close" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import brandconfig from "@/brandconfig";
import { CurrencyMenu, LanguageMenuTopBar, CustomerSupportMenu } from "./menu";
import { useRoute } from "vue-router";
import Usps from "@/pages/event/Usps.vue";

defineOptions({
  inheritAttrs: false,
});

const route = useRoute();
const usps = ref(brandconfig?.usps);
// By name, so a language-prefixed path (/nl/checkout) counts too.
const isCheckoutPage = computed(() => route.name === "checkout");
</script>
